import { ref } from 'vue'

import { defineStore } from 'pinia'

import * as aggr from '@/api-generator/aggr/index'

export const useShortUrlStore = defineStore('shortUrl', () => {
  const $reset = () => {
    setCompanyUuId('')
    setOrganizationId('')
  }

  const subTags = ref<aggr.ShortUrlQuerySubtagRs[]>([])
  const setSubTags = (tags: aggr.ShortUrlQuerySubtagRs[]) => {
    subTags.value = tags
  }

  /**
   * 編輯群組內個別短網址
   */
  const isEditingGroup = ref(false)
  const setIsEditingGroup = (status: boolean) => {
    isEditingGroup.value = status
  }

  const selectedOrganizationId = ref('')
  const setOrganizationId = (id: string) => {
    selectedOrganizationId.value = id
  }
  const selectedCompanyUuId = ref('')
  const setCompanyUuId = (id: string) => {
    selectedCompanyUuId.value = id
  }

  return {
    $reset,
    subTags,
    setSubTags,
    selectedOrganizationId,
    setOrganizationId,
    selectedCompanyUuId,
    setCompanyUuId,
    isEditingGroup,
    setIsEditingGroup
  }
})
